import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import './i18n';
import { App } from './App';
import { purgeLegacyPersistedTokens } from './api/tokens';
import { applyTheme, readTheme } from './lib/theme';

// 早期版本把 token 存过磁盘，升级后的设备上要主动抹掉
purgeLegacyPersistedTokens();

// 在第一次渲染之前定好浅色 / 深色，不然会先闪一下另一套颜色（CR-081）
applyTheme(readTheme());

const container = document.getElementById('root');
if (!container) throw new Error('找不到 #root 挂载点');

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
